// import axios from "axios"
import { inspectionAPI } from "../../axios";

export const actions = {

    //Property Inspection
    GetPropertyInspection(context, data){
        return inspectionAPI.get(`PropertyInspection/All/${data}`);
    },
    GetSinglePropertyInspection(context, data){
        return inspectionAPI.get(`PropertyInspection/${data}`);
    },
    AddPropertyInspection(context, data){
        return inspectionAPI.post(`PropertyInspection/Add`, data);
    },
    UpdatePropertyInspection(context, data){
        return inspectionAPI.put(`PropertyInspection/${data.id}`, data);
    },
    DeletePropertyInspection(context, data){
        return inspectionAPI.delete(`PropertyInspection/${data}`, data);
    },
    PostPropertyInspection(context, data){
        return inspectionAPI.put(`PropertyInspection/Post/${data}`);
    },
    UnpostPropertyInspection(context, data){
        return inspectionAPI.put(`PropertyInspection/Unpost/${data}`);
    },

}